import { useEffect } from 'react';
import { useSystemWebSocket } from '../SystemWebSocketContext';
import { useChatRequests } from '../ChatRequestsContext';
import { isAuthenticated } from '../common';

const ChatRequestsTracker = () => {
  const { subscribe } = useSystemWebSocket();
  const {
    loadIncomingRequests,
    loadOutgoingRequests,
    setIncomingRequests,
    setOutgoingRequests,
  } = useChatRequests();

  useEffect(() => {
    let isMounted = true;

    const loadAll = async () => {
      const authenticated = await isAuthenticated();
      if (!authenticated || !isMounted) {
        return;
      }
      await Promise.all([loadIncomingRequests(), loadOutgoingRequests()]);
    };

    loadAll();

    const unsubscribeChatRequests = subscribe('chat_requests', (data) => {
      setIncomingRequests(data.data?.requests || []);
    });

    const unsubscribeOutgoing = subscribe('outgoing_chat_requests', (data) => {
      setOutgoingRequests(data.data?.requests || []);
    });

    const unsubscribeIncoming = subscribe('chat_request', () => {
      loadIncomingRequests();
    });

    const unsubscribeOutgoingSingle = subscribe('outgoing_chat_request', () => {
      loadOutgoingRequests();
    });

    const unsubscribeRejected = subscribe('chat_request_rejected', () => {
      loadOutgoingRequests();
    });

    const unsubscribeRemoved = subscribe('chat_request_removed', () => {
      loadIncomingRequests();
      loadOutgoingRequests();
    });

    const unsubscribeCreated = subscribe('chat_created', () => {
      loadIncomingRequests();
    });

    const unsubscribeConnected = subscribe('ws_connected', () => {
      loadAll();
    });

    const handleUserLoggedIn = () => {
      loadAll();
    };

    window.addEventListener('userLoggedIn', handleUserLoggedIn);

    return () => {
      isMounted = false;
      window.removeEventListener('userLoggedIn', handleUserLoggedIn);
      unsubscribeChatRequests();
      unsubscribeOutgoing();
      unsubscribeIncoming();
      unsubscribeOutgoingSingle();
      unsubscribeRejected();
      unsubscribeRemoved();
      unsubscribeCreated();
      unsubscribeConnected();
    };
  }, [
    subscribe,
    loadIncomingRequests,
    loadOutgoingRequests,
    setIncomingRequests,
    setOutgoingRequests,
  ]);

  return null;
};

export default ChatRequestsTracker;
